import React, { useEffect, useState } from "react";
import { MdEvent, MdHome, MdCameraAlt, MdInfo } from "react-icons/md";
import { FaListUl, FaWpforms } from "react-icons/fa";
import { LINK_BOOK_NOW } from "../common/links";
import { PRIMARY_BUTTON } from "../common/styles";
import Navlink from "../common/Navlink";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { useNavigate, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();

  // 🧭 Detect if on /admin route
  const isAdminRoute = location.pathname === "/admin";

  // 🔐 Check if user has admin claim
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const token = await user.getIdTokenResult();
        setIsAdmin(!!token.claims.admin);
      } else {
        setIsAdmin(false);
      }
    });
    return unsubscribe;
  }, [auth]);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/");
  };

  return (
    <>
      <header className="bg-transparent w-full max-h-40 bg-cover flex items-center justify-start">
        <div className="max-w-xl">
          <img
            src={`${process.env.PUBLIC_URL}/images/text.png`}
            alt="Garden and Bee"
            loading="eager"
          />
          <h1 className="hidden">Garden and Bee Beauty Salon</h1>
        </div>
      </header>

      <header className="sticky top-0 h-20 w-full flex items-center justify-between py-3 z-[100] bg-background">
        {/* Left navigation */}
        <div className="hidden lg:flex">
          <ul className="flex items-center justify-center xl:text-xl text-primary_dark">
            <li className="mr-2 xl:mr-4">
              <Navlink url="home" name="HOME" />
            </li>
            <li className="mx-2 xl:mx-4">
              <Navlink url="services" name="SERVICES" />
            </li>
            <li className="mx-2 xl:mx-4">
              <Navlink url="gallery" name="GALLERY" />
            </li>
            <li className="mx-2 xl:mx-4">
              <Navlink url="forms" name="FORMS" />
            </li>
            <li className="ml-2 xl:ml-4">
              <Navlink url="about" name="ABOUT US" />
            </li>
          </ul>
        </div>

        {/* Center logo */}
        <div className="absolute lg:absolute lg:left-1/2 lg:translate-x-[-50%]">
          <img
            src={`${process.env.PUBLIC_URL}/images/icon.png`}
            alt="Garden and Bee"
            className="h-20"
            loading="eager"
          />
        </div>

        {/* Right side button */}
        <div className="flex ml-auto">
          {isAdminRoute && isAdmin ? (
            <button
              onClick={handleLogout}
              className={`${PRIMARY_BUTTON} px-2 md:px-6 text-sm lg:text-base shadow-xl`}
            >
              Logout
            </button>
          ) : (
            <a
              href={LINK_BOOK_NOW}
              className={`${PRIMARY_BUTTON} px-2 md:px-6 text-sm lg:text-base shadow-xl`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="hidden md:inline">Book Now</span>
              <span className="inline md:hidden">Book</span>
            </a>
          )}
        </div>
      </header>

      {/* Mobile bottom nav */}
      <nav className="lg:hidden fixed inset-x-0 bottom-0 z-[100] border-t border-neutral-200 bg-background/80 backdrop-blur">
        <div className="flex items-center justify-around text-primary_dark text-xs md:text-sm py-2">
          <Navlink
            url="home"
            name={
              <span className="flex flex-col items-center gap-0.5">
                <MdHome className="text-lg" />
                <span>Home</span>
              </span>
            }
          />
          <Navlink
            url="services"
            name={
              <span className="flex flex-col items-center gap-0.5">
                <FaListUl className="text-lg" />
                <span>Services</span>
              </span>
            }
          />
          <Navlink
            url="gallery"
            name={
              <span className="flex flex-col items-center gap-0.5">
                <MdCameraAlt className="text-lg" />
                <span>Gallery</span>
              </span>
            }
          />
          <Navlink
            url="forms"
            name={
              <span className="flex flex-col items-center gap-0.5">
                <FaWpforms className="text-lg" />
                <span>Forms</span>
              </span>
            }
          />
          <Navlink
            url="about"
            name={
              <span className="flex flex-col items-center gap-0.5">
                <MdInfo className="text-lg" />
                <span>About</span>
              </span>
            }
          />
          <a
            href={LINK_BOOK_NOW}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center gap-0.5 font-semibold"
          >
            <MdEvent className="text-lg" />
            <span>Book</span>
          </a>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
